import React from 'react'
import numbro from 'numbro';

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// @material-ui/core components
import Icon from "@material-ui/core/Icon";
import Typography from "@material-ui/core/Typography";

import dashGeneralPageStyle from "assets/jss/prehnit/views/dashGeneralPageStyle.jsx";

import { withNamespaces } from "react-i18next";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";

import CLCDistChartCard from "components/CLCDataCards/CLCDistChartCard.jsx";
import CLCTrendsChartCard from "components/CLCDataCards/CLCTrendsChartCard.jsx";
import CLCTableCard from "components/CLCDataCards/CLCTableCard.jsx";
import CLCExportCard from "components/CLCDataCards/CLCExportCard.jsx";

import { sortAreas, sortClasses } from "./dashHelpers.js";

import { Context } from "Context.jsx";

import { API } from "services/api";

class CLCDashSingle extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      sortType: 0,
      sortFunc: sortClasses,

      allData: [],
      distData: [],
      trendsData: [],

      zoomDistChart: 100,
      zoomTrendsChart: 100
    }

    this.handleSort = this.handleSort.bind(this);
    this.handleZoomDistChart = this.handleZoomDistChart.bind(this);
    this.handleZoomTrendsChart = this.handleZoomTrendsChart.bind(this);
  }

  handleSort() {
    if (this.state.sortType === 0) {
      this.setState({
        sortType: 1,
        sortFunc: sortAreas
      })
    } else {
      this.setState({
        sortType: 0,
        sortFunc: sortClasses
      })
    }
  }

  handleZoomDistChart(val) {
    this.setState({
      zoomDistChart: val
    })
  }

  handleZoomTrendsChart(val) {
    this.setState({
      zoomTrendsChart: val
    })
  }

  componentDidMount() {
    API.getDataAllRegions(this.props.categoryCode)
      .then(data => {
        let distData = data;
        let codeCount = distData.length;
        if (this.props.distChartIgnoreCodes) {
          distData = distData.filter(function (item) {
            return this.props.distChartIgnoreCodes.indexOf(item["kod_3"]) === -1;
          }.bind(this));
        }

        this.setState({
          totalArea: 5659400, //TODO: Calc sum
          codeCount: codeCount,
          allData: data,
          distData: distData
        })
      })

    API.getTrendsAllRegions(this.props.categoryCode)
      .then(data => {
        if (this.props.trendsChartIgnoreCodes) {
          data = data.filter(function (item) {
            return this.props.trendsChartIgnoreCodes.indexOf(item["k3"]) === -1;
          }.bind(this));
        }
        this.setState({
          trendsData: data
        })
      })
  }

  render() {
    const { t, classes } = this.props;
    return (
      <div>
        <GridContainer>
          <GridItem xs={12} sm={12} md={4}>
            <Card>
              <CardHeader color="warning">
                <CardIcon color="warning">
                  <Icon>folder</Icon>
                </CardIcon>
                <h4 className={classes.cardIconTitle}>{t("pagecontent:dash-country-total-area")}</h4>
              </CardHeader>
              <CardBody className={classes.cardRaised}>
                <Context.Consumer>
                  {ctx =>
                    <Typography component="h2" variant="display3" gutterBottom align="center">
                      {numbro(ctx.unit.transform(this.state.totalArea)).format()} <small>{ctx.unit.short}</small>
                    </Typography>
                  }
                </Context.Consumer>
              </CardBody>
            </Card>
            <br />
            <Card>
              <CardHeader color="info">
                <CardIcon color="info">
                  <Icon>bar_chart</Icon>
                </CardIcon>
                <h4 className={classes.cardIconTitle}>{t("pagecontent:dash-country-number-of-classes")}</h4>
              </CardHeader>
              <CardBody className={classes.cardRaised}>
                <Typography component="h2" variant="display3" gutterBottom align="center">
                  {this.state.codeCount}
                </Typography>
              </CardBody>
            </Card>

          </GridItem>
          <GridItem xs={12} sm={12} md={8}>
            <CLCDistChartCard
              id="chart-dist-primary"
              color="primary"
              title={t("map:class-distribution")}
              alwaysDefaultTitle={true}
              subtitle={t("map:level-3")}
              data={this.state.distData}

              showSort={true}
              sortType={this.state.sortType}
              sortFunc={this.state.sortFunc}
              onSetSort={this.handleSort}

              showZoom={true}
              zoom={this.state.zoomDistChart}
              onSetZoom={this.handleZoomDistChart}

              showSync={false}
            />
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12} sm={12} md={6}>
            <CLCTrendsChartCard
              id="chart-trends-primary"
              color="primary"
              title={t("map:trends")}
              subtitle={t("map:level-3")}
              height="500px"
              trendsData={this.state.trendsData}
              idCol="k3"
              areaCol="p3"
              zoom={this.state.zoomTrendsChart}
              onSetZoom={this.handleZoomTrendsChart}
            />
            <br />
            <CLCExportCard
              color="info"
              title={t('common:export')}
              categoryCode="drzava"
              hasFilter={false}

              allData={this.state.allData}
              trendsData={this.state.trendsData}

              single
              sortType={this.state.sortType}
              sortFunc={this.state.sortFunc}

              chartIds={["chart-dist-primary", "chart-trends-primary"]}

              reportType="all"
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <CLCTableCard
              single
              color="danger"
              title={t("map:class-list")}
              subtitle={t("map:level-3")}
              allData={this.state.allData}
              sortType={this.state.sortType}
              sortFunc={this.state.sortFunc}
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>

          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

export default withNamespaces()(withStyles(dashGeneralPageStyle)(CLCDashSingle));